import { useLanguage } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";
import { AppStoreButtons } from "@/components/AppStoreButtons";
import { SmartLink } from "@/components/SmartLink";
import { useConsent } from "@/context/ConsentContext";
import { WEB_APP_URL, WEB_APP_ENABLED } from "@/data/content";

export const Footer = () => {
  const { t } = useLanguage();
  const { openSettings } = useConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-[var(--line)] bg-[#060806]">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo testId="footer-logo-link" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[var(--ink-2)]">{t.footer.tagline}</p>
            <p className="eyebrow mt-8 !text-[0.62rem] text-[var(--ink-3)]">{t.footer.download}</p>
            <AppStoreButtons idPrefix="footer" compact className="mt-3" />
          </div>

          <div className="grid gap-10 sm:grid-cols-2 lg:col-span-5 lg:col-start-7">
            {t.footer.columns.map((col) => (
              <div key={col.title}>
                <h4 className="eyebrow !text-[0.62rem]">{col.title}</h4>
                <ul className="mt-5 space-y-3">
                  {col.links
                    .filter((link) => WEB_APP_ENABLED || link.href !== WEB_APP_URL)
                    .map((link) => (
                    <li key={link.label}>
                      <SmartLink href={link.href} className="text-sm text-[var(--ink-2)] transition-colors hover:text-white">
                        {link.label}
                      </SmartLink>
                    </li>
                    ))}
                  {col.title === t.footer.columns[1].title && (
                    <li>
                      <button type="button" onClick={openSettings} className="text-sm text-[var(--ink-2)] transition-colors hover:text-white" data-testid="footer-cookie-settings">
                        {t.consent.manage}
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-5 border-t border-[var(--line)] pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-[var(--ink-3)]">
            © {year} Outlander LB GmbH · HuntersMapp. {t.footer.rights}{" "}
            <span className="whitespace-nowrap">
              {t.footer.credit}{" "}
              <a href="https://sb-konzept.de" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                SBK Solutions GmbH
              </a>
            </span>
          </p>
          <div className="flex items-center gap-4">
            <span className="font-mono text-[11px] text-[var(--ink-3)]">v2.0</span>
            <LanguageToggle />
          </div>
        </div>
      </div>
    </footer>
  );
};
